import colors from "@evertrue/et-variables/src/styles/variables.scss";

export default colors;
